const reviews = [
  {
    name: "משפחת לוי",
    event: "בת מצווה",
    text: "השארנו את כל האורחים מבושמים מבשר עד היום! הפוד טראק היה מרכז החגיגה. אושר אמיתי לראות איך כולם ליקקו את הידיים מרוב התלהבות. תודה ליאור!",
    stars: 5,
  },
  {
    name: "דני לוי - מנהל HR",
    event: "אירוע חברה - 150 עובדים",
    text: "הזמנו את העגלה לאירוע השנתי של החברה ולא התאכזבנו. הבריסקט נמס בפה, האסאדו היה מושלם. כל העובדים ביקשו שנחזור לאותו קייטרינג בשנה הבאה.",
    stars: 5,
  },
  {
    name: "מיכל אברהם",
    event: "יום הולדת 40 - גינה פרטית",
    text: "חוויה בלתי נשכחת! החיתוך הפרונטלי מול האורחים יצר אווירה מדהימה. כולם ביקשו את הפרטים של ליאור. שירות אישי ברמה הכי גבוהה.",
    stars: 5,
  },
  {
    name: "יוסי גרינברג",
    event: "מסיבת רווקים - 60 איש",
    text: "הכי טוב שהיה לנו! הבשר, האווירה, השירות - הכל על הפנים. ליאור אדם מקצועי ונחמד ברמה אחרת. חוויה שתשאיר אתכם מרוצים ומלאי תשוקה לעוד!",
    stars: 5,
  },
  {
    name: "רחל מזרחי",
    event: "בר מצווה - 300 אורחים",
    text: "הזמנו לאירוע גדול ולא האמנו שיצא כל כך טוב. כל הנתחים היו מוכנים בזמן ובאיכות מעולה. מחוייבים לחוויה בלתי נשכחת עם טעם של עוד. תודה ליאור!",
    stars: 5,
  },
  {
    name: "אמיר שפירא",
    event: "אירוע פרטי - 80 אורחים",
    text: "פשוט הכי טעים שאכלתי בחיים. הבריסקט עם עישון ממושך זה משהו אחר לגמרי. לא רק הבשר מושלם - גם החוויה שלנו! חייבים להזמין שוב!",
    stars: 5,
  },
];

const Testimonials = () => {
  return (
    <section className="py-20 bg-[#fff8f0]" dir="rtl">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <span
            className="inline-block bg-[#e85d04]/10 text-[#e85d04] px-4 py-1.5 rounded-full text-sm font-semibold mb-4"
            style={{ fontFamily: "'Assistant', sans-serif" }}
          >
            מה הלקוחות אומרים
          </span>
          <h2
            className="text-[#1a0a00] font-black text-4xl md:text-5xl mb-4"
            style={{ fontFamily: "'Assistant', sans-serif" }}
          >
            אירועים שהפכו
            <br />
            לחוויה בלתי נשכחת
          </h2>
          <p
            className="text-[#7a5c44] text-lg"
            style={{ fontFamily: "'Assistant', sans-serif" }}
          >
            נשמח להיות חלק מהאירוע הבא שלכם
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {reviews.map((r) => (
            <div
              key={r.name}
              className="bg-white rounded-2xl p-6 border border-[#f0e0d0]"
            >
              <div className="flex gap-1 mb-3">
                {Array.from({ length: r.stars }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#e85d04] text-sm"></i>
                ))}
              </div>
              <p
                className="text-[#3d2010] text-sm leading-relaxed mb-5"
                style={{ fontFamily: "'Assistant', sans-serif" }}
              >
                "{r.text}"
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-[#e85d04]/15 rounded-full">
                  <i className="ri-user-fill text-[#e85d04]"></i>
                </div>
                <div>
                  <div
                    className="text-[#1a0a00] font-bold text-sm"
                    style={{ fontFamily: "'Assistant', sans-serif" }}
                  >
                    {r.name}
                  </div>
                  <div
                    className="text-[#9a7060] text-xs"
                    style={{ fontFamily: "'Assistant', sans-serif" }}
                  >
                    {r.event}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
